<script setup lang="ts">
import { computed } from 'vue';

type ImageEntry = string | { src: string; className?: string };

const props = defineProps<{
    images: ImageEntry[];
    /** @deprecated unused; use durationSeconds */
    speed?: number;
    /** Marquee loop duration in seconds (one quarter of the duplicated strip). */
    durationSeconds?: number;
}>();

const resolvedDurationSeconds = computed(() => {
    const n = props.durationSeconds;
    if (typeof n === 'number' && n > 0) {
        return n;
    }

    return 30;
});

const duplicated = computed(() => {
    const imgs = props.images ?? [];
    return [...imgs, ...imgs, ...imgs, ...imgs];
});

const src = (item: ImageEntry) => (typeof item === 'string' ? item : item.src);
const cls = (item: ImageEntry) => (typeof item === 'string' ? 'h-10' : (item.className ?? 'h-10'));
</script>

<template>
    <div class="relative flex h-[100px] w-full items-center overflow-hidden">
        <div class="animate-marquee flex items-center" :style="{ animationDuration: `${resolvedDurationSeconds}s` }">
            <div
                v-for="(img, index) in duplicated"
                :key="index"
                class="flex shrink-0 items-center justify-center px-10"
            >
                <img :src="src(img)" alt="Partner logo" :class="['block w-auto object-contain', cls(img)]" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.animate-marquee {
    width: max-content;
    animation-name: marquee;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}

@keyframes marquee {
    from { transform: translateX(0); }
    to { transform: translateX(-25%); }
}
</style>
